import React, { useMemo, useState } from 'react';
import { BreadcrumbItem } from '@ktag/styleguide/dist/components/breadcrumb/react/breadcrumb.types';
import { useTranslation } from 'react-i18next';

const BreadcrumbsContext = React.createContext<{
  currentItems: BreadcrumbItem[];
  setBreadcrumbItems: (items: BreadcrumbItem[]) => void;
  navigationCurrent: string;
  navigationSource: string;
}>(null);

interface Props {
  navigationCurrent: string;
  navigationSource: string;
  children: React.ReactNode;
}

export const BreadcrumbsContextProvider = ({
  navigationCurrent,
  navigationSource,
  children,
}: Props) => {
  const { t } = useTranslation('wap');

  const baseItem = {
    title: t('breadcrumb_home'),
    url: '#',
  };

  const [currentItems, setCurrentItems] = useState<BreadcrumbItem[]>([baseItem]);

  const setBreadcrumbItems = (items: BreadcrumbItem[]) => {
    const itemsWithHash = items.map(({ url, ...rest }) => ({ ...rest, url: `#${url}` }));
    setCurrentItems([baseItem, ...itemsWithHash]);
  };

  const value = useMemo(
    () => ({
      currentItems,
      setBreadcrumbItems,
      navigationCurrent,
      navigationSource,
    }),
    [currentItems, setBreadcrumbItems],
  );

  return (
    <BreadcrumbsContext.Provider value={value}>{children}</BreadcrumbsContext.Provider>
  );
};

export default BreadcrumbsContext;
